module.exports = __webpack_public_path__ + "img/wei.4a69e007.png";